import React from "react";
import PropTypes from "prop-types";

// This is more or less copied from the filter in WordPress.

const DuotoneSvgFilter = ({ id, values }) => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 0 0"
    width="0"
    height="0"
    focusable="false"
    role="none"
    hidden
  >
    <defs>
      <filter id={id}>
        <feColorMatrix
          // Use sRGB instead of linearRGB so transparency looks correct.
          colorInterpolationFilters="sRGB"
          type="matrix"
          // Use perceptual brightness to convert to grayscale.
          values="
                .299 .587 .114 0 0
                .299 .587 .114 0 0
                .299 .587 .114 0 0
                .299 .587 .114 0 0
                "
        />
        <feComponentTransfer
          // Use sRGB instead of linearRGB to be consistent with how CSS gradients work.
          colorInterpolationFilters="sRGB"
        >
          <feFuncR type="table" tableValues={values.r} />
          <feFuncG type="table" tableValues={values.g} />
          <feFuncB type="table" tableValues={values.b} />
          <feFuncA type="table" tableValues={values.a} />
        </feComponentTransfer>
        <feComposite
          // Re-mask the image with the original transparency since the feColorMatrix above loses that information.
          in2="SourceGraphic"
          operator="in"
        />
      </filter>
    </defs>
  </svg>
);

DuotoneSvgFilter.propTypes = {
  id: PropTypes.string,
  values: PropTypes.shape({
    r: PropTypes.string,
    g: PropTypes.string,
    b: PropTypes.string,
    a: PropTypes.string,
  }),
};

export default DuotoneSvgFilter;
